/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { GroupHeaderController } from './group-header-component';

/**
 * AngularJS component that handles creating the group.
 */
const groupCreateComponent = {
  templateUrl: 'ajs/components/group/create.html',
  controllerAs: 'groupHeaderCtrl',
  controller: ['$attrs', '$rootScope', '$scope', '$state', '$translate', '$window', 'Restangular',
    'AeroDialogService', 'BulbAuthService', 'BulbBrowserService', 'BulbBusyService',
    'BulbGoogleClassroomImportService', 'BulbGroupService', 'BulbModalService',
    'AUTH', 'GROUP', GroupHeaderController],
};

export default groupCreateComponent;
